import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=4730856c&scoped=true&lang=pug&"
import script from "./UploadFiles.vue?vue&type=script&lang=js&"
export * from "./UploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=4730856c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730856c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4730856c')) {
      api.createRecord('4730856c', component.options)
    } else {
      api.reload('4730856c', component.options)
    }
    module.hot.accept("./UploadFiles.vue?vue&type=template&id=4730856c&scoped=true&lang=pug&", function () {
      api.rerender('4730856c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/UploadFiles.vue"
export default component.exports